<template>
  <div>
    <teleport to="#body">
      <!--      <spinner></spinner>-->
      <loading v-if="isLoading" />
    </teleport>

    <div class="wrap" id="wrap">
      <div class="body">
        <router-view v-slot="{ Component }">
          <header-bar />
          <!-- 상단 헤더바 -->
          <component :is="Component" />
          <!--          <transition name="fade">-->
          <!--            <component :is="Component" />-->
          <!--          </transition>-->
          <!-- 하단 네비게이션바 -->
          <menu-bar />
        </router-view>
      </div>
      <!-- 전체화면 modal component -->
      <teleport to="#wrap" v-for="(item, index) in modalComponents" :key="index">
        <component :index="index" :is="item.component.name" v-bind="item" @close="fnCloseModal" />
      </teleport>
      <!-- alert modal component -->
      <teleport to="#wrap" v-for="(item, index) in modalAlertComponents" :key="index">
        <component :index="index" :is="item.component.name" v-bind="item" @close="fnCloseModalAlert" />
      </teleport>
    </div>
  </div>
</template>
<script setup>
import HeaderBar from '@/components/common/layouts/TheHeader';
import MenuBar from '@/components/common/modal/menu';
import Spinner from '@/components/common/layouts/spinner/index';
import Loading from '@/components/common/modal/loading/index.vue';
import { computed, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const { getters, dispatch } = useStore();
const route = useRoute();
const { proxy } = getCurrentInstance();
const isLoading = computed(() => getters['layout/getIsLoading']);
const modalComponents = computed(() => getters['layout/getModalComponents']);
const routeLayout = computed(() => getters['layout/getRouteLayout']);
const modalAlertComponents = computed(() => getters['layout/getModalAlertComponents']);

/** methods **/
const fnCloseModalAlert = (index = 0) => {
  dispatch('layout/closeModalAlertComponent', { index });
};
const fnRemoveAllModalAlertComponent = () => {
  dispatch('layout/removeAllModalAlertComponent');
};
const fnCloseModal = (index = 0) => {
  dispatch('layout/closeModalComponent', { index });
};
const fnRemoveAllModalComponent = () => {
  dispatch('layout/removeAllModalComponent');
};
/** watch route 이동시 side-bar, modal close **/
watch(route, () => {
  if (!proxy.$Util.isEmpty(modalAlertComponents)) {
    fnRemoveAllModalAlertComponent();
  }
  if (!proxy.$Util.isEmpty(modalComponents)) {
    fnRemoveAllModalComponent();
  }
});
</script>

<style lang="scss">
.body {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
}
</style>
